import {useState} from "react";
import {HomeSection} from "../../../common/HomeSection.jsx";
import {Icons} from "../../../common/Icons.jsx";
import {MAIN_REJESTR_API_LONG} from "../../../utils/consts.js";
import {useSelector} from "react-redux";
import {AIChatModalContent} from "../../../common/index.js";
import HasRole from "../../../common/authirization/HasRole.jsx";

const ViewWpHome = () => {
    const [showAIChat, setShowAIChat] = useState(false)
    const profilId = useSelector(state => state.user.profilId);
    const permissions = useSelector(state => state.user.permissions || [])
    const isOwner = Array.isArray(permissions) && permissions.includes('owner')

    return (
        <>
            <HomeSection
                title={'Realizacja'}
                items={[

                    {
                        icon: <Icons.task size={80}/>,
                        title: 'Projekty',
                        text: 'Przejdź do listy projektów - przeglądaj, dodawaj, modyfikuj i usuwaj projekty',
                        actionLink: `/wp/${MAIN_REJESTR_API_LONG}/lista`,
                        actionText: 'Przejdź do projektów'
                    },
                    {
                        icon: <Icons.addToGroup size={80}/>,
                        title: 'Profil',
                        text: 'Przejdź do zarządzania profilem',
                        actionLink: isOwner
                            ? `/wp/profile/konta/${profilId}`
                            : `/wp/profile/podglad/${profilId}`,
                        actionText: 'Przejdź do profilu'
                    },
                ]}
            />
            <HomeSection
                title={'Narzędzia'}
                items={[
                    // {
                    //     icon: <Icons.translate size={80}/>,
                    //     title: 'Słowniki',
                    //     text: 'Przejdź do managera słowników - dodawaj, modyfikuj i usuwaj słowniki dostępne w aplikacji',
                    //     actionLink: '/wp/slowniki/lista',
                    //     actionText: 'Przejdź do słowników'
                    // },
                    // {
                    //     icon: <Icons.config size={80}/>,
                    //     title: 'Konfiguracja',
                    //     text: 'Konfiguracja aplikacji',
                    //     actionLink: '/wp/konfiguracja/lista',
                    //     actionText: 'Przejdź do konfiguracji'
                    // },
                    // {
                    //     icon: <Icons.excel size={80}/>,
                    //     title: 'Raporty',
                    //     text: 'Lista raportów',
                    //     actionLink: '/wp/raporty',
                    //     actionText: 'Przejdź do konfiguracji'
                    // },
                    {
                        icon: <Icons.user size={80}/>,
                        title: 'Moje dane',
                        text: 'Informacje o twoim koncie',
                        actionLink: '/uzytkownik/moje-dane',
                        actionText: 'Przejdź do swoich danych'
                    },
                    // {
                    //     icon: <Icons.aiDb size={80}/>,
                    //     title: 'Czat z bazą',
                    //     perms:['ai_raporty_podglad'],
                    //     text: 'Rozmawiaj z bazą danych',
                    //     onClick: () => setShowAIChat(true),
                    // },
                ]}
            />
            {/*{showAIChat &&*/}
            {/*    <HasRole roles={['ai_raporty_podglad']} mode={'all'}>*/}
            {/*        <AIChatModalContent*/}
            {/*            show={showAIChat}*/}
            {/*            handleClose={() => setShowAIChat(false)}*/}
            {/*        />*/}
            {/*    </HasRole>*/}
            {/*}*/}

        </>
    );
};

export default ViewWpHome;
